import type { ReactNode } from 'react';
import { CoinsIcon } from '@/components/icons';
import { Table, Td, Th } from '@/components/page';
import { EmptyState, cx } from '@/components/ui';

/** A report's table: the first column a label, the rest figures, right-aligned. */
export function ReportTable({
  headers,
  rows,
  empty,
}: {
  headers: string[];
  rows: ReactNode[][];
  empty: string;
}) {
  if (rows.length === 0) {
    return (
      <div className="border-t border-line">
        <EmptyState title={empty} icon={<CoinsIcon />} />
      </div>
    );
  }

  return (
    <div className="overflow-x-auto border-t border-line">
      <Table>
        <thead>
          <tr>
            {headers.map((header, index) => (
              <Th key={header} align={index === 0 ? 'start' : 'end'}>
                {header}
              </Th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, index) => (
                <Td
                  key={index}
                  align={index === 0 ? 'start' : 'end'}
                  data-numeric={index > 0 ? '' : undefined}
                  // The card's own edge closes the last row.
                  className={cx('text-ink [tr:last-child_&]:border-b-0', index > 0 && 'tabular-nums')}
                >
                  {cell}
                </Td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
